import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, record_type, uint8_type, class_type, int32_type, int16_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class ContractTypePriceDTO extends Record {
    constructor(Name, ContractTypePriceId, ContractContractNr, RGUMinimumCostExclVat, RGUACostExclVat, VatPercent, AccountNo) {
        super();
        this.Name = Name;
        this.ContractTypePriceId = (ContractTypePriceId | 0);
        this.ContractContractNr = (ContractContractNr | 0);
        this.RGUMinimumCostExclVat = RGUMinimumCostExclVat;
        this.RGUACostExclVat = RGUACostExclVat;
        this.VatPercent = VatPercent;
        this.AccountNo = (AccountNo | 0);
    }
}

export function ContractTypePriceDTO$reflection() {
    return record_type("Containers.WholesaleRGU.Model.ContractTypePriceDTO", [], ContractTypePriceDTO, () => [["Name", string_type], ["ContractTypePriceId", int16_type], ["ContractContractNr", int32_type], ["RGUMinimumCostExclVat", class_type("System.Decimal")], ["RGUACostExclVat", class_type("System.Decimal")], ["VatPercent", uint8_type], ["AccountNo", int32_type]]);
}

export class ContractTypePriceRguStratumDTO extends Record {
    constructor(ContractTypePriceId, EffectiveOverNumContracts, RGUACostExclVat) {
        super();
        this.ContractTypePriceId = (ContractTypePriceId | 0);
        this.EffectiveOverNumContracts = (EffectiveOverNumContracts | 0);
        this.RGUACostExclVat = RGUACostExclVat;
    }
}

export function ContractTypePriceRguStratumDTO$reflection() {
    return record_type("Containers.WholesaleRGU.Model.ContractTypePriceRguStratumDTO", [], ContractTypePriceRguStratumDTO, () => [["ContractTypePriceId", int16_type], ["EffectiveOverNumContracts", int32_type], ["RGUACostExclVat", class_type("System.Decimal")]]);
}

export class FeeGeneratedDTO extends Record {
    constructor(Generator$, FeeId, InvoiceeNr, ContractNr, Parameters, StartDate, EndDate, AccountNo) {
        super();
        this.Generator = Generator$;
        this.FeeId = (FeeId | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = ContractNr;
        this.Parameters = Parameters;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.AccountNo = (AccountNo | 0);
    }
}

export function FeeGeneratedDTO$reflection() {
    return record_type("Containers.WholesaleRGU.Model.FeeGeneratedDTO", [], FeeGeneratedDTO, () => [["Generator", string_type], ["FeeId", int32_type], ["InvoiceeNr", option_type(int32_type)], ["ContractNr", option_type(int32_type)], ["Parameters", string_type], ["StartDate", class_type("System.DateOnly")], ["EndDate", option_type(class_type("System.DateOnly"))], ["AccountNo", int32_type]]);
}

export class FeeGeneratedUpdateDTO extends Record {
    constructor(Generator$, FeeId, InvoiceeNr, ContractNr, Parameters, StartDate, EndDate, AccountNo, OldParameters) {
        super();
        this.Generator = Generator$;
        this.FeeId = (FeeId | 0);
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = ContractNr;
        this.Parameters = Parameters;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.AccountNo = (AccountNo | 0);
        this.OldParameters = OldParameters;
    }
}

export function FeeGeneratedUpdateDTO$reflection() {
    return record_type("Containers.WholesaleRGU.Model.FeeGeneratedUpdateDTO", [], FeeGeneratedUpdateDTO, () => [["Generator", string_type], ["FeeId", int32_type], ["InvoiceeNr", option_type(int32_type)], ["ContractNr", option_type(int32_type)], ["Parameters", string_type], ["StartDate", class_type("System.DateOnly")], ["EndDate", option_type(class_type("System.DateOnly"))], ["AccountNo", int32_type], ["OldParameters", string_type]]);
}

